import { UUID } from '@myme/utils';

// NON-AUTHENTICATED
export const loginPageRoute = '/auth/login';
export const registerPageRoute = '/auth/register';
export const resetPasswordPageRoute = '/auth/reset-password';

// AUTH
export const feedPageRoute = '/app/feed';
export const libraryPageRoute = '/app/library';
export const searchResultsPageRoute = '/app/search-results';

// AUTH - PROFILE
export const creatorProfilePageRoute = (creatorId: string) => `/app/profile/overview/${creatorId}`;
export const profileSettingsPageRoute = '/app/profile/settings';

// AUTH - INTRESTS
const myme = '/app/mymes';
export const myLocationBasedMymesPageRoute = `${myme}/location-based`;
export const myTimeBasedMymesPageRoute = `${myme}/time-based`;
export const myCoursesPageRoute = `${myme}/courses`;

export const userMymes = {
  LOCATION_BASED: myLocationBasedMymesPageRoute,
  TIME_BASED: myTimeBasedMymesPageRoute,
  COURSE: myCoursesPageRoute
};

export const mymeDetailsPageRoute = (mymeId: string) => `${myme}/details/${mymeId}`;
export const mymeDetailsFinishPageRoute = (mymeId: string) => `${myme}/details/${mymeId}/finish`;
export const mymeDetailsBlobContentPageRoute = (blobId: string, mymeId: string) =>
  `${myme}/details/${mymeId}/blob/content/${blobId}`;

// AUTH - INTRESTS - EDITOR
export const mymeEditorBlockedPageRoute = `${myme}/content-blocked`;
const mymeEditor = `${myme}/editor`;
export const mymeEditorCreatorStepPageRoute = `${mymeEditor}/create`;
export const mymeEditorDetailsStepPageRoute = (mymeId: string) => `${mymeEditor}/details/${mymeId}`;
export const mymeEditorContentStepPageRoute = (mymeId: string) => `${mymeEditor}/content/${mymeId}`;
export const mymeEditorFinishStepPageRoute = (mymeId: string) => `${mymeEditor}/finish/${mymeId}`;

// AUTH - INTRESTS - EDITOR - BLOBS
const mymeEditorBlobs = 'blobs';
export const blobsLibraryPageRoute = `${mymeEditor}/${mymeEditorBlobs}/library`;
export const blobCreatorPageRoute = `${mymeEditor}/${mymeEditorBlobs}/create`;
export const blobEditorPageRoute = (blobId: string) => `${mymeEditor}/${mymeEditorBlobs}/edit/${blobId}`;

// AUTH - SUPERADMIN
const superAdmin = '/app/superadmin';
export const superAdminReviewsPageRoute = `${superAdmin}/reviews`;
export const superAdminReportedReviewsPageRoute = `${superAdmin}/reported-reviews`;
export const superAdminReviewReportListPageRoute = (reviewId: UUID) =>
  `${superAdmin}/reported-reviews/${reviewId}/report-list`;
export const superAdminMymesPageRoute = `${superAdmin}/mymes`;
export const superAdminReportedMymesPageRoute = `${superAdmin}/reported-mymes`;
export const superAdminAccountsPageRoute = `${superAdmin}/accounts`;
export const superAdminMymeReportListPageRoute = (mymeId: UUID) => `${superAdmin}/reported-mymes/${mymeId}/report-list`;

// OTHERS
export const somethingWentWrongPageRoute = '/500';
export const pageNotFoundPageRoute = '/404';
export const premiumPageBlockerPageRoute = '/premium-required';
